import {ChangeDetectorRef, Component, Input} from "@angular/core";
import {AbstractField} from "../field/abstract-field";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    selector: "woa-text-area-field",
    templateUrl: "./text-area-field.component.html",
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: TextAreaFieldComponent, multi: true}]
})
export class TextAreaFieldComponent extends AbstractField {
    @Input() maxLength: number;
    @Input() spellCheck: boolean = true;

    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }
}



// WEBPACK FOOTER //
// ./src/app/inputs/text-area-field/text-area-field.component.ts